export default "__VITE_ASSET__b901cf7b__"